import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  OnDestroy,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core'
import { DatePipe } from '@angular/common'
import { ShowToastResult } from '@siemens/ix-angular'
import { IxButton, ToastService } from '@siemens/ix-angular/standalone'

@Component({
  selector: 'login-expiration-warning',
  imports: [DatePipe, IxButton],
  template: ` <ng-template #customToast let-toast>
    <div>
      <div>
        You login expires at {{ time() ?? '' | date: 'medium' }} and can not be extended please logout and log in again.
      </div>
      <ix-button [variant]="'danger'" (click)="buttonClicked()">Logout</ix-button>
    </div>
  </ng-template>`,
  styleUrl: './login-expiration-warning.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginExpirationWarningComponent implements OnDestroy {
  readonly expirationTime = input.required<Date | undefined>()
  readonly logout = output<void>()

  ngOnDestroy() {
    this.toast?.close()
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly customToastRef = viewChild<TemplateRef<any>>('customToast')
  readonly #toastService = inject(ToastService)

  toast: ShowToastResult | undefined

  buttonClicked() {
    this.logout.emit()
    this.toast?.close()
  }

  readonly time = computed(() => {
    const expirationTime = this.expirationTime()
    if (!expirationTime) {
      return undefined
    }
    return expirationTime.toISOString()
  })

  readonly eff1 = effect(() => {
    const time = this.expirationTime()
    if (this.customToastRef() && time) {
      this.showToastMessage()
    }
  })

  async showToastMessage() {
    this.toast = await this.#toastService.show({
      message: this.customToastRef()!,
      autoClose: false,
      type: 'warning',
    })
  }
}
